import React, { type ChangeEvent } from 'react';

import { Button, Typography } from '@pkg/components';

import { type Guarantee } from '@app/client';

interface GuaranteeConfigProps {
    handleChange: (e: ChangeEvent<HTMLInputElement>, name: string, type: string) => void;
    newGuarantee: Guarantee;
    addConfigGroupOptions: (type: string) => void;
    deleteConfigGroupOption: (i: number, type: string) => void;
    guarantees: Guarantee[];
}

const GuaranteeConfig = ({
    handleChange,
    newGuarantee,
    addConfigGroupOptions,
    deleteConfigGroupOption,
    guarantees,
}: GuaranteeConfigProps) => {
    return (
        <div className="config-item">
            <div className="config-options">
                <Typography type="headline" size={18}>
                    Guarantee:
                </Typography>
                <br />
                <div className="input-container number">
                    <label title="The number of guaranteed drops of this type in the loot box" htmlFor="weightMinScore">
                        Count:
                    </label>
                    <input
                        value={newGuarantee.count}
                        onChange={(e) => handleChange(e, 'count', 'guarantee')}
                        type="number"
                        name="count"
                        min={0}
                    />
                </div>
                <div className="input-container number">
                    <label
                        title="The lowest (inclusive) rhythm score range for guaranteed drop"
                        htmlFor="weightMaxScore"
                    >
                        Min Score:
                    </label>
                    <input
                        value={newGuarantee.min_score}
                        onChange={(e) => handleChange(e, 'min_score', 'guarantee')}
                        type="number"
                        name="guaranteeMinScore"
                        min={0}
                    />
                </div>
                <div className="input-container number">
                    <label title="The highest (exclusive) rhythm score range for guaranteed drop" htmlFor="ipr">
                        Max Score:
                    </label>
                    <input
                        value={newGuarantee.max_score}
                        onChange={(e) => handleChange(e, 'max_score', 'guarantee')}
                        type="number"
                        name="max_score"
                        min={0}
                    />
                </div>
                <div style={{ width: 200, margin: '20px 0' }}>
                    <Button
                        type="button"
                        onClick={() => addConfigGroupOptions('guarantee')}
                        size="small"
                        color="secondary"
                    >
                        Add Guarantee
                    </Button>
                </div>
            </div>
            {guarantees.length > 0 && (
                <table className="lb-table">
                    <tbody>
                        <tr className="row-header type">
                            <td>count</td>
                            <td>min score</td>
                            <td>max score</td>
                            <td>del</td>
                        </tr>

                        {guarantees.map((g, i) => {
                            return (
                                <tr key={i + 'g'} className="type">
                                    <td>{g.count}</td>
                                    <td>{g.min_score}</td>
                                    <td>{g.max_score}</td>
                                    <td>
                                        <img
                                            onClick={() => deleteConfigGroupOption(i, 'guarantee')}
                                            className="close"
                                            src="/assets/icons/close-icon.svg"
                                            alt=""
                                        />
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            )}
        </div>
    );
};
export default GuaranteeConfig;
